/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '../../../../payment/payment.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@ngx-translate/core/src/translate.pipe';
import * as i3 from '@ngx-translate/core/src/translate.service';
import * as i4 from '@angular/common';
import * as i5 from '../../../../../../app/shared/components/social-login-button/facebook/social-login-button.facebook.component';
import * as i6 from 'angular2-social-login/dist/auth.service';
import * as i7 from '@angular/router';
import * as i8 from '../../../../../../app/payment/services/identification-steps.service';
const styles_SocialLoginButtonFacebookComponent:any[] = [i0.styles];
export const RenderType_SocialLoginButtonFacebookComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_SocialLoginButtonFacebookComponent,data:{}});
function View_SocialLoginButtonFacebookComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),4,'button',[['class',
      'col btn btn-sm btn-fb'],['role','button'],['type','button']],[[8,'disabled',
      0]],[[(null as any),'click']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:any = _v.component;
    if (('click' === en)) {
      const pd_0:any = ((<any>_co.fbLogin()) !== false);
      ad = (pd_0 && ad);
    }
    return ad;
  },(null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n    '])),(_l()(),
      i1.ɵeld(2,0,(null as any),(null as any),0,'i',[['class','fa fa-facebook-square mr-sm']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(3,(null as any),['','\n'])),i1.ɵpid(131072,i2.TranslatePipe,
          [i3.TranslateService,i1.ChangeDetectorRef])],(null as any),(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.disabled;
    _ck(_v,0,0,currVal_0);
    const currVal_1:any = i1.ɵunv(_v,3,0,i1.ɵnov(_v,4).transform('PAYMENT.IDENTIFICATION.IDENTIFICATION.CONNECT_WITH_FB'));
    _ck(_v,3,0,currVal_1);
  });
}
export function View_SocialLoginButtonFacebookComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),
      View_SocialLoginButtonFacebookComponent_1)),i1.ɵdid(1,16384,(null as any),0,
      i4.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf']},(null as any))],
      (_ck,_v) => {
        var _co:i5.SocialLoginButtonFacebookComponent = _v.component;
        const currVal_0:any = _co.allowed;
        _ck(_v,1,0,currVal_0);
      },(null as any));
}
export function View_SocialLoginButtonFacebookComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'social-login-button-facebook',
      ([] as any[]),(null as any),(null as any),(null as any),View_SocialLoginButtonFacebookComponent_0,
      RenderType_SocialLoginButtonFacebookComponent)),i1.ɵdid(1,49152,(null as any),
      0,i5.SocialLoginButtonFacebookComponent,[i6.AuthService,i7.ActivatedRoute,i8.IdentificationStepsService],
      (null as any),(null as any))],(null as any),(null as any));
}
export const SocialLoginButtonFacebookComponentNgFactory:i1.ComponentFactory<i5.SocialLoginButtonFacebookComponent> = i1.ɵccf('social-login-button-facebook',
    i5.SocialLoginButtonFacebookComponent,View_SocialLoginButtonFacebookComponent_Host_0,
    {disabled:'disabled'},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2NvZGVidWlsZC9vdXRwdXQvc3JjMzg5NDQ2MTU1OS9zcmMvc3JjL2FwcC9zaGFyZWQvY29tcG9uZW50cy9zb2NpYWwtbG9naW4tYnV0dG9uL2ZhY2Vib29rL3NvY2lhbC1sb2dpbi1idXR0b24uZmFjZWJvb2suY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL2NvZGVidWlsZC9vdXRwdXQvc3JjMzg5NDQ2MTU1OS9zcmMvc3JjL2FwcC9zaGFyZWQvY29tcG9uZW50cy9zb2NpYWwtbG9naW4tYnV0dG9uL2ZhY2Vib29rL3NvY2lhbC1sb2dpbi1idXR0b24uZmFjZWJvb2suY29tcG9uZW50LnRzIiwibmc6Ly8vY29kZWJ1aWxkL291dHB1dC9zcmMzODk0NDYxNTU5L3NyYy9zcmMvYXBwL3NoYXJlZC9jb21wb25lbnRzL3NvY2lhbC1sb2dpbi1idXR0b24vZmFjZWJvb2svc29jaWFsLWxvZ2luLWJ1dHRvbi5mYWNlYm9vay5jb21wb25lbnQuaHRtbCIsIm5nOi8vL2NvZGVidWlsZC9vdXRwdXQvc3JjMzg5NDQ2MTU1OS9zcmMvc3JjL2FwcC9zaGFyZWQvY29tcG9uZW50cy9zb2NpYWwtbG9naW4tYnV0dG9uL2ZhY2Vib29rL3NvY2lhbC1sb2dpbi1idXR0b24uZmFjZWJvb2suY29tcG9uZW50LnRzLlNvY2lhbExvZ2luQnV0dG9uRmFjZWJvb2tDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8YnV0dG9uIGNsYXNzPVwiY29sIGJ0biBidG4tc20gYnRuLWZiXCIgdHlwZT1cImJ1dHRvblwiIHJvbGU9XCJidXR0b25cIlxuICAgICAgICAqbmdJZj1cImFsbG93ZWRcIlxuICAgICAgICAoY2xpY2spPVwiZmJMb2dpbigpXCJcbiAgICAgICAgW2Rpc2FibGVkXT1cImRpc2FibGVkXCI+XG4gICAgPGkgY2xhc3M9XCJmYSBmYS1mYWNlYm9vay1zcXVhcmUgbXItc21cIj48L2k+e3tcIlBBWU1FTlQuSURFTlRJRklDQVRJT04uSURFTlRJRklDQVRJT04uQ09OTkVDVF9XSVRIX0ZCXCIgfCB0cmFuc2xhdGV9fVxuPC9idXR0b24+IiwiPHNvY2lhbC1sb2dpbi1idXR0b24tZmFjZWJvb2s+PC9zb2NpYWwtbG9naW4tYnV0dG9uLWZhY2Vib29rPiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztvQkNBQTtNQUFBO01BQUE7SUFBQTtJQUFBO0lBRVE7TUFBQTtNQUFBO0lBQUE7SUFGUjtFQUFBLGdDQUc4Qiw4Q0FDMUI7YUFBQTtVQUFBO01BQTJDO1VBQUE7O0lBRHZDO0lBSFIsV0FHUSxTQUhSO0lBSStDO0lBQUE7Ozs7b0JBSi9DO01BQUEsbURBQUE7Y0FBQTs7O1FBQ1E7UUFEUixXQUNRLFNBRFI7Ozs7b0JDQUE7TUFBQTttREFBQSxVQUFBO01BQUE7TUFBQTs7OzsifQ==



// WEBPACK FOOTER //
// /codebuild/output/src3894461559/src/src/$$_gendir/app/shared/components/social-login-button/facebook/social-login-button.facebook.component.ngfactory.ts